// Gray reads as "other/none", so it's reserved for aggregates and kept out of
// the per-space palette.
const SPACE_COLOR_RAMPS = [
  "purple",
  "sky",
  "green",
  "orange",
  "pink",
  "teal",
  "yellow",
  "red",
];

export const SPACE_COLORS = SPACE_COLOR_RAMPS.map(
  (ramp) => `var(--${ramp}-600)`
);

// A space keeps the same ramp across every chart by indexing the palette on a
// stable id-sort of all team spaces, rather than each chart's own display order.
function spaceRampMap(
  spaces: ReadonlyArray<{ id: string; mode: string }>
): Map<string, string> {
  const map = new Map<string, string>();
  spaces
    .filter((space) => space.mode !== "personal")
    .map((space) => space.id)
    .sort()
    .forEach((id, i) =>
      map.set(id, SPACE_COLOR_RAMPS[i % SPACE_COLOR_RAMPS.length]!)
    );
  return map;
}

export function spaceColorMap(
  spaces: ReadonlyArray<{ id: string; mode: string }>
): Map<string, string> {
  const map = new Map<string, string>();
  for (const [id, ramp] of spaceRampMap(spaces)) {
    map.set(id, `var(--${ramp}-600)`);
  }
  return map;
}

// The 200 tint of each space's ramp, used as the solid "unused" headroom track
// in budget donuts so remaining allowance reads as a crisp light shade rather
// than a semi-transparent wash of the 600.
export function spaceTrackColorMap(
  spaces: ReadonlyArray<{ id: string; mode: string }>
): Map<string, string> {
  const map = new Map<string, string>();
  for (const [id, ramp] of spaceRampMap(spaces)) {
    map.set(id, `var(--${ramp}-200)`);
  }
  return map;
}

export const MONITORING_CHART_HEIGHT = 160;
export const MONITORING_PANEL_PADDING = 32;
export const MONITORING_PANEL_GAP = 20;

// Below this viewport height the Workflows grid collapses to a single
// horizontally-scrolling row — the height-axis mirror of the single-column
// collapse at narrow widths — so the charts never shrink to a tiny "small state".
export const MONITORING_SHORT_VIEWPORT_HEIGHT = 700;
// Minimum card edge in the collapsed 1-D layouts, so charts stay readable.
export const MONITORING_CARD_MIN = 340;
// Cap for content-hugging cards (execution volume) in the single-row layout,
// so a chart with many spaces grows but never dominates before its bars compress.
export const MONITORING_CARD_MAX = 720;

const ACTIVE_HEADER_HEIGHT = 64;
const CHART_WITH_LABELS = MONITORING_CHART_HEIGHT + 8 + 12;

export const MONITORING_PANEL_HEIGHT =
  MONITORING_PANEL_PADDING * 2 +
  ACTIVE_HEADER_HEIGHT +
  MONITORING_PANEL_GAP +
  CHART_WITH_LABELS;
